import { ApiService } from '../services/api.service';

export const sendContactEmail = async (emailData) => {
    return ApiService.fetch('/contact/send', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(emailData)
    });
}; 